import { useEffect, useState } from "react";
import { fetchGetCompanyBusinessHours, fetchGetCompanySiteSettings } from "../../../services/api";

export default function Footer({ company }) {

    const [businessHours, setBusinessHours] = useState([]);

    const [activeMenu, setActiveMenu] = useState(false)

    const [active, setActive] = useState(false)

    const handleChange = (menu) => {
        setActiveMenu(activeMenu === menu ? null : menu);
    };

    const showHours = () => {
        setActive(prev => !prev)
    }

    useEffect(() => {
        const fetchBusinessHours = async () => {
            const hours = [];
            try {
                const res = await fetchGetCompanyBusinessHours();
                if (res.monday && res.tuesday && res.wednesday && res.thursday && res.friday) {
                    const sameWeekdayHours =
                        res.mondayOpeningTime === res.tuesdayOpeningTime &&
                        res.mondayOpeningTime === res.wednesdayOpeningTime &&
                        res.mondayOpeningTime === res.thursdayOpeningTime &&
                        res.mondayOpeningTime === res.fridayOpeningTime &&
                        res.mondayClosingTime === res.tuesdayClosingTime &&
                        res.mondayClosingTime === res.wednesdayClosingTime &&
                        res.mondayClosingTime === res.thursdayClosingTime &&
                        res.mondayClosingTime === res.fridayClosingTime;

                    if (sameWeekdayHours) {
                        hours.push({ name: 'Segunda à Sexta', openingTime: res.mondayOpeningTime.slice(0, 5), closingTime: res.mondayClosingTime.slice(0, 5) });
                    } else {
                        if (res.monday) {
                            hours.push({ name: 'Segunda-feira', openingTime: res.mondayOpeningTime.slice(0, 5), closingTime: res.mondayClosingTime.slice(0, 5) });
                        }
                        if (res.tuesday) {
                            hours.push({ name: 'Terça-feira', openingTime: res.tuesdayOpeningTime.slice(0, 5), closingTime: res.tuesdayClosingTime.slice(0, 5) });
                        }
                        if (res.wednesday) {
                            hours.push({ name: 'Quarta-feira', openingTime: res.wednesdayOpeningTime.slice(0, 5), closingTime: res.wednesdayClosingTime.slice(0, 5) });
                        }
                        if (res.thursday) {
                            hours.push({ name: 'Quinta-feira', openingTime: res.thursdayOpeningTime.slice(0, 5), closingTime: res.thursdayClosingTime.slice(0, 5) });
                        }
                        if (res.friday) {
                            hours.push({ name: 'Sexta-feira', openingTime: res.fridayOpeningTime.slice(0, 5), closingTime: res.fridayClosingTime.slice(0, 5) });
                        }
                    }
                }
                if (res.saturday) {
                    hours.push({ name: 'Sábado', openingTime: res.saturdayOpeningTime.slice(0, 5), closingTime: res.saturdayClosingTime.slice(0, 5) });
                }
                if (res.sunday) {
                    hours.push({ name: 'Domingo', openingTime: res.sundayOpeningTime.slice(0, 5), closingTime: res.sundayClosingTime.slice(0, 5) });
                }
                if (res.holiday) {
                    hours.push({ name: 'Feriado', openingTime: res.holidayOpeningTime.slice(0, 5), closingTime: res.holidayClosingTime.slice(0, 5) });
                }
                setBusinessHours(hours);
            } catch (error) {
                console.error('Erro ao buscar os horários de funcionamento:', error);
            }
        };

        fetchBusinessHours();
    }, []);

    const [vehiclePages, setVehiclePages] = useState([])
    const [servicesPages, setServicesPages] = useState([])

    useEffect(() => {
        const vehiclePages = []
        const servicesPages = []
        fetchGetCompanySiteSettings()
            .then(res => {
                res.showNew === true ? vehiclePages.push({ route: "novos", name: "0 Km" }) : null;
                res.showUsed === true ? vehiclePages.push({ route: "seminovos", name: "Seminovos" }) : null;
                res.showArmored === true ? vehiclePages.push({ route: "blindados", name: "Blindados" }) : null;
                res.showInsurance === true ? servicesPages.push({ route: "seguro", name: "Seguro" }) : null;
                res.showFinancing === true ? servicesPages.push({ route: "financiamento", name: "Financiamento" }) : null;
                res.showVehiclePurchase === true ? servicesPages.push({ route: "venda-seu-veiculo", name: "Venda seu Veículo" }) : null;
                setVehiclePages(vehiclePages)
                setServicesPages(servicesPages)
            })
    }, [])

    const cnpjMask = (number) => {
        number.replace(/\D/g, '');
        return number.replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, "$1. $2. $3/$4-$5")
    }

    return (
        <>
            <footer>
                <div className="footer-wrapper position-relative z-1">
                    <div className="footer-copyright">
                        <div className="visible">
                            <div className="d-flex justify-content-around align-items-center p-4">
                                <div className={`d-flex flex-direction-column justify-content-around align-items-center company-contacts`}>
                                    <div className="d-flex gap-4">
                                        {company.facebook ?
                                            <a href={company.facebook} target={'_blank'} rel="noreferrer" aria-label="Acesse o facebook da nossa loja">
                                                <div className="social-background">
                                                    {company.facebook ? <span><i className="fab fa-facebook-f"></i></span> : null}
                                                </div>
                                            </a>
                                            : null}
                                        {company.instagram ?
                                            <a href={company.instagram} target={'_blank'} rel="noreferrer" aria-label="Acesse o instagram da nossa loja">
                                                <div className="social-background">
                                                    {company.instagram ? <span><i className="fab fa-instagram"></i></span> : null}
                                                </div>
                                            </a>
                                            : null}
                                        {company.youtube ?
                                            <a href={company.youtube} target={'_blank'} rel="noreferrer" aria-label="Acesse o youtube da nossa loja">
                                                <div className="social-background">
                                                    {company.youtube ? <span><i className="fab fa-youtube"></i></span> : null}
                                                </div>
                                            </a>
                                            : null}
                                        {company.tiktok ?
                                            <a href={company.tiktok} target={'_blank'} rel="noreferrer" aria-label="Acesse o tiktok da nossa loja">
                                                <div className="social-background">
                                                    {company.tiktok ? <span><i className="fab fa-tiktok"></i></span> : null}
                                                </div>
                                            </a> : null}
                                    </div>
                                </div>
                            </div>
                            <div className="footer-separator">
                                <span></span>
                                <i className="fas fa-diamond mx-3"></i>
                                <span></span>

                            </div>
                            <div className="d-flex align-items-center quick-link-box">
                                <div className="col-lg-12 d-flex flex-wrap">
                                    <div className="border-sm col-lg-9 col-sm-12 d-flex flex-wrap">
                                        <div className="quick-links col-lg-3 col-md-6">
                                            <div className="d-flex justify-content-start align-items-center gap-2">
                                                <div className="quick-link-icon">
                                                    <i className="flaticon-speedometer"></i>
                                                </div>
                                                <h5 className="mb-0 white">VEÍCULOS</h5>
                                                <div className={`d-none arrow-down ${activeMenu === "vehicles" ? 'rotate' : null}`} onClick={() => handleChange("vehicles")}>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                    >
                                                        <path
                                                            d="M4 8L12 16L20 8"
                                                            stroke="currentColor"
                                                            stroke-width="3.5"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                        />
                                                    </svg>
                                                </div>
                                            </div>

                                            <div className={`mobile-pages ${activeMenu === "vehicles" ? "open" : ""}`}>
                                                <ul>
                                                    {vehiclePages.map((page, index) => (
                                                        <a key={index} href={`/${page.route}`}><li className="white">{page.name}</li></a>
                                                    ))}
                                                </ul>
                                            </div>

                                        </div>
                                        <div className="quick-links col-lg-3 col-md-6">
                                            <div className="d-flex justify-content-start align-items-center gap-2">
                                                <div className="quick-link-icon">
                                                    <i className="flaticon-shield"></i>
                                                </div>
                                                <h5 className="mb-0 white">SERVIÇOS</h5>
                                                <div className={`d-none arrow-down ${activeMenu === "services" ? 'rotate' : null}`} onClick={() => handleChange("services")}>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                    >
                                                        <path
                                                            d="M4 8L12 16L20 8"
                                                            stroke="currentColor"
                                                            stroke-width="3.5"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                        />
                                                    </svg>
                                                </div>
                                            </div>

                                            <div className={`mobile-pages ${activeMenu === "services" ? "open" : ""}`}>
                                                <ul>
                                                    {servicesPages.map((page, index) => (
                                                        <a key={index} href={`/${page.route}`}><li className="white">{page.name}</li></a>
                                                    ))}
                                                </ul>
                                            </div>

                                        </div>

                                        <div className="quick-links col-lg-3 col-md-6">
                                            <div className="d-flex justify-content-start align-items-center gap-2">
                                                <div className="quick-link-icon">
                                                    <i className="flaticon-info"></i>
                                                </div>
                                                <h5 className="mb-0 white">INSTITUCIONAL</h5>
                                                <div className={`d-none arrow-down ${activeMenu === "institutional" ? 'rotate' : null}`} onClick={() => handleChange("institutional")}>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                    >
                                                        <path
                                                            d="M4 8L12 16L20 8"
                                                            stroke="currentColor"
                                                            stroke-width="3.5"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                        />
                                                    </svg>
                                                </div>
                                            </div>

                                            <div className={`mobile-pages ${activeMenu === "institutional" ? "open" : ""}`}>
                                                <ul>
                                                    <a href={`/sobre-nos`}><li className="white">Sobre Nós</li></a>
                                                    <a href={`/sobre-nos`}><li className="white">Nossa Visão</li></a>
                                                    <a href={`/sobre-nos`}><li className="white">Nossos Valores</li></a>
                                                    <a href={`/sobre-nos`}><li className="white">Nossa Missão</li></a>
                                                </ul>
                                            </div>

                                        </div>

                                        <div className="quick-links col-lg-3 col-md-6 quick-links col-lg-3 separator">
                                            <div className="d-flex justify-content-start align-items-center gap-2">
                                                <div className="quick-link-icon">
                                                    <i className="flaticon-headphones"></i>
                                                </div>
                                                <h5 className="mb-0 white">ATENDIMENTO</h5>
                                                <div className={`d-none arrow-down ${activeMenu === "support" ? 'rotate' : null}`} onClick={() => handleChange("support")}>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                    >
                                                        <path
                                                            d="M4 8L12 16L20 8"
                                                            stroke="currentColor"
                                                            stroke-width="3.5"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                        />
                                                    </svg>
                                                </div>
                                            </div>

                                            <div className={`mobile-pages ${activeMenu === "support" ? "open" : ""}`}>
                                                <ul>
                                                    <a href={`/contato`}><li className="white">Contato</li></a>
                                                    <a><li className="white">Horário de Funcionamento <i style={{ cursor: "pointer" }} className={`bi bi-caret-down-fill px-1 ${active ? 'rotate-on-click' : ''}`} onClick={showHours}></i></li></a>
                                                    <div className={`horario-dropdown ${active ? 'open' : ''}`}>
                                                        {businessHours.map((hour, index) => (
                                                            <div
                                                                key={index}
                                                                className="horario-item"
                                                                style={{ animationDelay: `${index * 0.15}s` }}
                                                            >
                                                                {hour.name}: {hour.openingTime} - {hour.closingTime}
                                                            </div>))}
                                                    </div>
                                                    {/* <li className="white">CNPJ : {cnpjMask(company.cnpj)}</li> */}
                                                </ul>
                                            </div>

                                        </div>

                                    </div>
                                    <div className="border-sm col-lg-3 col-sm-12 col-xxs-12 d-flex justify-content-center">
                                        <div className="quick-links" style={{ alignItems: "center !important" }}>
                                            <div className="d-flex justify-content-center align-items-center gap-2">
                                                <div className="quick-link-icon">
                                                    <i className="flaticon-email"></i>
                                                </div>
                                                <h5 className="mb-0 white">FALE CONOSCO</h5>
                                            </div>
                                            <p className="text-center">Estamos prontos para te ajudar!</p>
                                            <div className="btn btn-secondary btn-md d-block btn-black col-lg-6" style={{ marginBottom: "10px" }}>
                                                <i></i>
                                                <a href="/contato"><span className="white">Entrar em Contato</span></a>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>
                    <div className="footer-copyright footer-copyright-margin-top">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-sm-7">
                                    <div className="copyright-text">
                                        <p className="mb-0">&copy; Todos os direitos reservados! Desenvolvido por &nbsp;&nbsp;<a href="https://bndv.com.br" target="_blank" rel="noreferrer">BNDV - Banco Nacional de Veículos</a></p>
                                    </div>
                                </div>
                                <div className="col-sm-5">
                                    <div className="copyright-links text-start text-sm-end mt-1 mt-sm-0">
                                        <a href="/termos">Termo de Uso e Política de Privacidade</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}